import React from "react";

// Custom Tailwind avatar — replaces CoreUI's CAvatar. Circle with initials (or
// arbitrary children). Pass `size` / `tone` rather than overriding via
// `className`, so they don't collide with the defaults in the cascade.
//  - solid: bold accent fill (page-subject avatars, e.g. doctor profile)
//  - glass: glassy accent chip that matches the rest of the UI chrome (the FAB,
//    active controls) — used by the user button.
const TONES = {
  solid: "tw:bg-accent tw:text-white",
  glass: "tw:bg-accent/15 tw:border tw:border-accent/40 tw:text-accent!",
} as const;

interface AvatarProps {
  children: React.ReactNode;
  className?: string;
  size?: string;
  tone?: keyof typeof TONES;
}

const Avatar = ({
  children,
  className = "",
  size = "tw:h-14 tw:w-14 tw:text-lg",
  tone = "solid",
}: AvatarProps) => (
  <div
    className={[
      "tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:font-semibold tw:select-none",
      size,
      TONES[tone],
      className,
    ].join(" ")}
  >
    {children}
  </div>
);

export default Avatar;
